/* tslint:disable */
/* eslint-disable */
/**
 * SUREnet crm-internal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface CollectionResultOfCrmAfdelingGetInternalAfdelingAfdelingDto
 */
export interface CollectionResultOfCrmAfdelingGetInternalAfdelingAfdelingDto {
    /**
     * 
     * @type {Array<CrmAfdelingGetInternalAfdelingAfdelingDto>}
     * @memberof CollectionResultOfCrmAfdelingGetInternalAfdelingAfdelingDto
     */
    result?: Array<CrmAfdelingGetInternalAfdelingAfdelingDto> | null;
    /**
     * 
     * @type {number}
     * @memberof CollectionResultOfCrmAfdelingGetInternalAfdelingAfdelingDto
     */
    status: number;
    /**
     * 
     * @type {ManagementModelsApiError}
     * @memberof CollectionResultOfCrmAfdelingGetInternalAfdelingAfdelingDto
     */
    error: ManagementModelsApiError;
}
/**
 * 
 * @export
 * @interface CollectionResultOfCrmGebruikersGetGebruikersLikeStringDto
 */
export interface CollectionResultOfCrmGebruikersGetGebruikersLikeStringDto {
    /**
     * 
     * @type {Array<CrmGebruikersGetGebruikersLikeStringDto>}
     * @memberof CollectionResultOfCrmGebruikersGetGebruikersLikeStringDto
     */
    result?: Array<CrmGebruikersGetGebruikersLikeStringDto> | null;
    /**
     * 
     * @type {number}
     * @memberof CollectionResultOfCrmGebruikersGetGebruikersLikeStringDto
     */
    status: number;
    /**
     * 
     * @type {ManagementModelsApiError}
     * @memberof CollectionResultOfCrmGebruikersGetGebruikersLikeStringDto
     */
    error: ManagementModelsApiError;
}
/**
 * 
 * @export
 * @interface CollectionResultOfCrmTussenPersonenTussenPersoonDto
 */
export interface CollectionResultOfCrmTussenPersonenTussenPersoonDto {
    /**
     * 
     * @type {Array<CrmTussenPersonenTussenPersoonDto>}
     * @memberof CollectionResultOfCrmTussenPersonenTussenPersoonDto
     */
    result?: Array<CrmTussenPersonenTussenPersoonDto> | null;
    /**
     * 
     * @type {number}
     * @memberof CollectionResultOfCrmTussenPersonenTussenPersoonDto
     */
    status: number;
    /**
     * 
     * @type {ManagementModelsApiError}
     * @memberof CollectionResultOfCrmTussenPersonenTussenPersoonDto
     */
    error: ManagementModelsApiError;
}
/**
 * 
 * @export
 * @interface CrmAfdelingGetInternalAfdelingAfdelingDto
 */
export interface CrmAfdelingGetInternalAfdelingAfdelingDto {
    /**
     * 
     * @type {number}
     * @memberof CrmAfdelingGetInternalAfdelingAfdelingDto
     */
    afdelingId: number;
    /**
     * 
     * @type {string}
     * @memberof CrmAfdelingGetInternalAfdelingAfdelingDto
     */
    omschrijving: string;
    /**
     * 
     * @type {string}
     * @memberof CrmAfdelingGetInternalAfdelingAfdelingDto
     */
    soort: string;
    /**
     * 
     * @type {number}
     * @memberof CrmAfdelingGetInternalAfdelingAfdelingDto
     */
    werkverdeler?: number | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum CrmDomainDomainTussenPersonenDirectePostVerzending {
    Adviseur = 'Adviseur',
    AdviseurEnRelatie = 'AdviseurEnRelatie',
    Relatie = 'Relatie'
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum CrmGebruikersGebruikerType {
    Systeem = 'Systeem',
    Intern = 'Intern',
    Test = 'Test',
    Demo = 'Demo',
    Adviseur = 'Adviseur',
    Maatschappij = 'Maatschappij'
}

/**
 * 
 * @export
 * @interface CrmGebruikersGetGebruikersLikeStringDto
 */
export interface CrmGebruikersGetGebruikersLikeStringDto {
    /**
     * 
     * @type {number}
     * @memberof CrmGebruikersGetGebruikersLikeStringDto
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof CrmGebruikersGetGebruikersLikeStringDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmGebruikersGetGebruikersLikeStringDto
     */
    naam?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmGebruikersGetGebruikersLikeStringDto
     */
    voornaam?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmGebruikersGetGebruikersLikeStringDto
     */
    voorletters?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmGebruikersGetGebruikersLikeStringDto
     */
    tussenvoegsel?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CrmGebruikersGetGebruikersLikeStringDto
     */
    advisorId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CrmGebruikersGetGebruikersLikeStringDto
     */
    advisorName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmGebruikersGetGebruikersLikeStringDto
     */
    volledigeNaam?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmGebruikersGetGebruikersLikeStringDto
     */
    telefoonnummer?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CrmGebruikersGetGebruikersLikeStringDto
     */
    beursBeschikbaar: boolean;
}
/**
 * 
 * @export
 * @interface CrmRelationsOntdubbelenRelatieContactpersoonContactpersoonDto
 */
export interface CrmRelationsOntdubbelenRelatieContactpersoonContactpersoonDto {
    /**
     * 
     * @type {number}
     * @memberof CrmRelationsOntdubbelenRelatieContactpersoonContactpersoonDto
     */
    id: number;
    /**
     * 
     * @type {boolean}
     * @memberof CrmRelationsOntdubbelenRelatieContactpersoonContactpersoonDto
     */
    ingebruik: boolean;
}
/**
 * 
 * @export
 * @interface CrmRelationsOntdubbelenRelatieContactpersoonOntdubbelRelatieContactpersoonDto
 */
export interface CrmRelationsOntdubbelenRelatieContactpersoonOntdubbelRelatieContactpersoonDto {
    /**
     * 
     * @type {number}
     * @memberof CrmRelationsOntdubbelenRelatieContactpersoonOntdubbelRelatieContactpersoonDto
     */
    relatienummer: number;
    /**
     * 
     * @type {Array<CrmRelationsOntdubbelenRelatieContactpersoonContactpersoonDto>}
     * @memberof CrmRelationsOntdubbelenRelatieContactpersoonOntdubbelRelatieContactpersoonDto
     */
    contactpersonen: Array<CrmRelationsOntdubbelenRelatieContactpersoonContactpersoonDto>;
}
/**
 * 
 * @export
 * @interface CrmRelationsOntdubbelenRelatieContactpersoonOntdubbelenRelatieContactpersonenResult
 */
export interface CrmRelationsOntdubbelenRelatieContactpersoonOntdubbelenRelatieContactpersonenResult {
    /**
     * 
     * @type {number}
     * @memberof CrmRelationsOntdubbelenRelatieContactpersoonOntdubbelenRelatieContactpersonenResult
     */
    relatienummer: number;
    /**
     * 
     * @type {Array<CrmRelationsOntdubbelenRelatieContactpersoonContactpersoonDto>}
     * @memberof CrmRelationsOntdubbelenRelatieContactpersoonOntdubbelenRelatieContactpersonenResult
     */
    contactpersonen: Array<CrmRelationsOntdubbelenRelatieContactpersoonContactpersoonDto>;
    /**
     * 
     * @type {Array<number>}
     * @memberof CrmRelationsOntdubbelenRelatieContactpersoonOntdubbelenRelatieContactpersonenResult
     */
    verwijderd: Array<number>;
}
/**
 * 
 * @export
 * @interface CrmTussenPersonenTussenPersoonDto
 */
export interface CrmTussenPersonenTussenPersoonDto {
    /**
     * 
     * @type {number}
     * @memberof CrmTussenPersonenTussenPersoonDto
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof CrmTussenPersonenTussenPersoonDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmTussenPersonenTussenPersoonDto
     */
    emailadres?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmTussenPersonenTussenPersoonDto
     */
    telefoonnummer?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CrmTussenPersonenTussenPersoonDto
     */
    defaultHoofdvervaldatumDag?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CrmTussenPersonenTussenPersoonDto
     */
    defaultHoofdvervaldatumMaand?: number | null;
    /**
     * 
     * @type {CrmDomainDomainTussenPersonenDirectePostVerzending}
     * @memberof CrmTussenPersonenTussenPersoonDto
     */
    defaultDirectePostVerzending: CrmDomainDomainTussenPersonenDirectePostVerzending;
    /**
     * 
     * @type {boolean}
     * @memberof CrmTussenPersonenTussenPersoonDto
     */
    mailVersturenVanuitSUREnet: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CrmTussenPersonenTussenPersoonDto
     */
    isZelfIncasserend: boolean;
}
/**
 * 
 * @export
 * @interface ManagementModelsApiError
 */
export interface ManagementModelsApiError {
    /**
     * 
     * @type {string}
     * @memberof ManagementModelsApiError
     */
    message?: string | null;
}
/**
 * 
 * @export
 * @interface Result1OfCrmRelationsOntdubbelenRelatieContactpersoonOntdubbelenRelatieContactpersonenResult
 */
export interface Result1OfCrmRelationsOntdubbelenRelatieContactpersoonOntdubbelenRelatieContactpersonenResult {
    /**
     * 
     * @type {CrmRelationsOntdubbelenRelatieContactpersoonOntdubbelenRelatieContactpersonenResult}
     * @memberof Result1OfCrmRelationsOntdubbelenRelatieContactpersoonOntdubbelenRelatieContactpersonenResult
     */
    result: CrmRelationsOntdubbelenRelatieContactpersoonOntdubbelenRelatieContactpersonenResult;
    /**
     * 
     * @type {number}
     * @memberof Result1OfCrmRelationsOntdubbelenRelatieContactpersoonOntdubbelenRelatieContactpersonenResult
     */
    status: number;
    /**
     * 
     * @type {ManagementModelsApiError}
     * @memberof Result1OfCrmRelationsOntdubbelenRelatieContactpersoonOntdubbelenRelatieContactpersonenResult
     */
    error: ManagementModelsApiError;
}

/**
 * AfdelingenApiApi - axios parameter creator
 * @export
 */
export const AfdelingenApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Dit zijn alle afdelingen die behoren tot tussenpersoonId = 1 <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingInzien</li></ul>
         * @summary Haal alle interne afdelingen op
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        afdelingenGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/afdelingen/intern`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AfdelingenApiApi - functional programming interface
 * @export
 */
export const AfdelingenApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AfdelingenApiApiAxiosParamCreator(configuration)
    return {
        /**
         * Dit zijn alle afdelingen die behoren tot tussenpersoonId = 1 <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingInzien</li></ul>
         * @summary Haal alle interne afdelingen op
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async afdelingenGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionResultOfCrmAfdelingGetInternalAfdelingAfdelingDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.afdelingenGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AfdelingenApiApi - factory interface
 * @export
 */
export const AfdelingenApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AfdelingenApiApiFp(configuration)
    return {
        /**
         * Dit zijn alle afdelingen die behoren tot tussenpersoonId = 1 <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingInzien</li></ul>
         * @summary Haal alle interne afdelingen op
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        afdelingenGet(options?: any): AxiosPromise<CollectionResultOfCrmAfdelingGetInternalAfdelingAfdelingDto> {
            return localVarFp.afdelingenGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AfdelingenApiApi - interface
 * @export
 * @interface AfdelingenApiApi
 */
export interface AfdelingenApiApiInterface {
    /**
     * Dit zijn alle afdelingen die behoren tot tussenpersoonId = 1 <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingInzien</li></ul>
     * @summary Haal alle interne afdelingen op
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AfdelingenApiApiInterface
     */
    afdelingenGet(options?: any): AxiosPromise<CollectionResultOfCrmAfdelingGetInternalAfdelingAfdelingDto>;

}

/**
 * AfdelingenApiApi - object-oriented interface
 * @export
 * @class AfdelingenApiApi
 * @extends {BaseAPI}
 */
export class AfdelingenApiApi extends BaseAPI implements AfdelingenApiApiInterface {
    /**
     * Dit zijn alle afdelingen die behoren tot tussenpersoonId = 1 <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingInzien</li></ul>
     * @summary Haal alle interne afdelingen op
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AfdelingenApiApi
     */
    public afdelingenGet(options?: any) {
        return AfdelingenApiApiFp(this.configuration).afdelingenGet(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * GebruikerApiApi - axios parameter creator
 * @export
 */
export const GebruikerApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.GebruikerInzien</li></ul>
         * @summary Zoek naar gebruikers
         * @param {string} [term] 
         * @param {CrmGebruikersGebruikerType} [gebruikerType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gebruikerSearch: async (term?: string, gebruikerType?: CrmGebruikersGebruikerType, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/gebruikers/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }

            if (gebruikerType !== undefined) {
                localVarQueryParameter['gebruikerType'] = gebruikerType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GebruikerApiApi - functional programming interface
 * @export
 */
export const GebruikerApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GebruikerApiApiAxiosParamCreator(configuration)
    return {
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.GebruikerInzien</li></ul>
         * @summary Zoek naar gebruikers
         * @param {string} [term] 
         * @param {CrmGebruikersGebruikerType} [gebruikerType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gebruikerSearch(term?: string, gebruikerType?: CrmGebruikersGebruikerType, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionResultOfCrmGebruikersGetGebruikersLikeStringDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gebruikerSearch(term, gebruikerType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GebruikerApiApi - factory interface
 * @export
 */
export const GebruikerApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GebruikerApiApiFp(configuration)
    return {
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.GebruikerInzien</li></ul>
         * @summary Zoek naar gebruikers
         * @param {string} [term] 
         * @param {CrmGebruikersGebruikerType} [gebruikerType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gebruikerSearch(term?: string, gebruikerType?: CrmGebruikersGebruikerType, options?: any): AxiosPromise<CollectionResultOfCrmGebruikersGetGebruikersLikeStringDto> {
            return localVarFp.gebruikerSearch(term, gebruikerType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GebruikerApiApi - interface
 * @export
 * @interface GebruikerApiApi
 */
export interface GebruikerApiApiInterface {
    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.GebruikerInzien</li></ul>
     * @summary Zoek naar gebruikers
     * @param {string} [term] 
     * @param {CrmGebruikersGebruikerType} [gebruikerType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GebruikerApiApiInterface
     */
    gebruikerSearch(term?: string, gebruikerType?: CrmGebruikersGebruikerType, options?: any): AxiosPromise<CollectionResultOfCrmGebruikersGetGebruikersLikeStringDto>;

}

/**
 * GebruikerApiApi - object-oriented interface
 * @export
 * @class GebruikerApiApi
 * @extends {BaseAPI}
 */
export class GebruikerApiApi extends BaseAPI implements GebruikerApiApiInterface {
    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.GebruikerInzien</li></ul>
     * @summary Zoek naar gebruikers
     * @param {string} [term] 
     * @param {CrmGebruikersGebruikerType} [gebruikerType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GebruikerApiApi
     */
    public gebruikerSearch(term?: string, gebruikerType?: CrmGebruikersGebruikerType, options?: any) {
        return GebruikerApiApiFp(this.configuration).gebruikerSearch(term, gebruikerType, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OntdubbelRelatieContactpersonenApi - axios parameter creator
 * @export
 */
export const OntdubbelRelatieContactpersonenApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
         * @summary Tijdelijk endpoint om contactpersonen te ontdubbelen in Level
         * @param {boolean} [verwijderenOverslaan] 
         * @param {Array<CrmRelationsOntdubbelenRelatieContactpersoonOntdubbelRelatieContactpersoonDto>} [crmRelationsOntdubbelenRelatieContactpersoonOntdubbelRelatieContactpersoonDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ontdubbelRelatieContactpersonenOntdubbelenRelatieContactPersoon: async (verwijderenOverslaan?: boolean, crmRelationsOntdubbelenRelatieContactpersoonOntdubbelRelatieContactpersoonDto?: Array<CrmRelationsOntdubbelenRelatieContactpersoonOntdubbelRelatieContactpersoonDto>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/relatie/contactpersonen`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (verwijderenOverslaan !== undefined) {
                localVarQueryParameter['verwijderenOverslaan'] = verwijderenOverslaan;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(crmRelationsOntdubbelenRelatieContactpersoonOntdubbelRelatieContactpersoonDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OntdubbelRelatieContactpersonenApi - functional programming interface
 * @export
 */
export const OntdubbelRelatieContactpersonenApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OntdubbelRelatieContactpersonenApiAxiosParamCreator(configuration)
    return {
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
         * @summary Tijdelijk endpoint om contactpersonen te ontdubbelen in Level
         * @param {boolean} [verwijderenOverslaan] 
         * @param {Array<CrmRelationsOntdubbelenRelatieContactpersoonOntdubbelRelatieContactpersoonDto>} [crmRelationsOntdubbelenRelatieContactpersoonOntdubbelRelatieContactpersoonDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ontdubbelRelatieContactpersonenOntdubbelenRelatieContactPersoon(verwijderenOverslaan?: boolean, crmRelationsOntdubbelenRelatieContactpersoonOntdubbelRelatieContactpersoonDto?: Array<CrmRelationsOntdubbelenRelatieContactpersoonOntdubbelRelatieContactpersoonDto>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Result1OfCrmRelationsOntdubbelenRelatieContactpersoonOntdubbelenRelatieContactpersonenResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ontdubbelRelatieContactpersonenOntdubbelenRelatieContactPersoon(verwijderenOverslaan, crmRelationsOntdubbelenRelatieContactpersoonOntdubbelRelatieContactpersoonDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OntdubbelRelatieContactpersonenApi - factory interface
 * @export
 */
export const OntdubbelRelatieContactpersonenApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OntdubbelRelatieContactpersonenApiFp(configuration)
    return {
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
         * @summary Tijdelijk endpoint om contactpersonen te ontdubbelen in Level
         * @param {boolean} [verwijderenOverslaan] 
         * @param {Array<CrmRelationsOntdubbelenRelatieContactpersoonOntdubbelRelatieContactpersoonDto>} [crmRelationsOntdubbelenRelatieContactpersoonOntdubbelRelatieContactpersoonDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ontdubbelRelatieContactpersonenOntdubbelenRelatieContactPersoon(verwijderenOverslaan?: boolean, crmRelationsOntdubbelenRelatieContactpersoonOntdubbelRelatieContactpersoonDto?: Array<CrmRelationsOntdubbelenRelatieContactpersoonOntdubbelRelatieContactpersoonDto>, options?: any): AxiosPromise<Array<Result1OfCrmRelationsOntdubbelenRelatieContactpersoonOntdubbelenRelatieContactpersonenResult>> {
            return localVarFp.ontdubbelRelatieContactpersonenOntdubbelenRelatieContactPersoon(verwijderenOverslaan, crmRelationsOntdubbelenRelatieContactpersoonOntdubbelRelatieContactpersoonDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OntdubbelRelatieContactpersonenApi - interface
 * @export
 * @interface OntdubbelRelatieContactpersonenApi
 */
export interface OntdubbelRelatieContactpersonenApiInterface {
    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
     * @summary Tijdelijk endpoint om contactpersonen te ontdubbelen in Level
     * @param {boolean} [verwijderenOverslaan] 
     * @param {Array<CrmRelationsOntdubbelenRelatieContactpersoonOntdubbelRelatieContactpersoonDto>} [crmRelationsOntdubbelenRelatieContactpersoonOntdubbelRelatieContactpersoonDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OntdubbelRelatieContactpersonenApiInterface
     */
    ontdubbelRelatieContactpersonenOntdubbelenRelatieContactPersoon(verwijderenOverslaan?: boolean, crmRelationsOntdubbelenRelatieContactpersoonOntdubbelRelatieContactpersoonDto?: Array<CrmRelationsOntdubbelenRelatieContactpersoonOntdubbelRelatieContactpersoonDto>, options?: any): AxiosPromise<Array<Result1OfCrmRelationsOntdubbelenRelatieContactpersoonOntdubbelenRelatieContactpersonenResult>>;

}

/**
 * OntdubbelRelatieContactpersonenApi - object-oriented interface
 * @export
 * @class OntdubbelRelatieContactpersonenApi
 * @extends {BaseAPI}
 */
export class OntdubbelRelatieContactpersonenApi extends BaseAPI implements OntdubbelRelatieContactpersonenApiInterface {
    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
     * @summary Tijdelijk endpoint om contactpersonen te ontdubbelen in Level
     * @param {boolean} [verwijderenOverslaan] 
     * @param {Array<CrmRelationsOntdubbelenRelatieContactpersoonOntdubbelRelatieContactpersoonDto>} [crmRelationsOntdubbelenRelatieContactpersoonOntdubbelRelatieContactpersoonDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OntdubbelRelatieContactpersonenApi
     */
    public ontdubbelRelatieContactpersonenOntdubbelenRelatieContactPersoon(verwijderenOverslaan?: boolean, crmRelationsOntdubbelenRelatieContactpersoonOntdubbelRelatieContactpersoonDto?: Array<CrmRelationsOntdubbelenRelatieContactpersoonOntdubbelRelatieContactpersoonDto>, options?: any) {
        return OntdubbelRelatieContactpersonenApiFp(this.configuration).ontdubbelRelatieContactpersonenOntdubbelenRelatieContactPersoon(verwijderenOverslaan, crmRelationsOntdubbelenRelatieContactpersoonOntdubbelRelatieContactpersoonDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TussenpersonenApiApi - axios parameter creator
 * @export
 */
export const TussenpersonenApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingInzien</li></ul>
         * @summary Haal alle actieve tussenpersonen op
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tussenpersonenGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/tussenpersonen`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TussenpersonenApiApi - functional programming interface
 * @export
 */
export const TussenpersonenApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TussenpersonenApiApiAxiosParamCreator(configuration)
    return {
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingInzien</li></ul>
         * @summary Haal alle actieve tussenpersonen op
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tussenpersonenGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CollectionResultOfCrmTussenPersonenTussenPersoonDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tussenpersonenGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TussenpersonenApiApi - factory interface
 * @export
 */
export const TussenpersonenApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TussenpersonenApiApiFp(configuration)
    return {
        /**
         *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingInzien</li></ul>
         * @summary Haal alle actieve tussenpersonen op
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tussenpersonenGet(options?: any): AxiosPromise<CollectionResultOfCrmTussenPersonenTussenPersoonDto> {
            return localVarFp.tussenpersonenGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TussenpersonenApiApi - interface
 * @export
 * @interface TussenpersonenApiApi
 */
export interface TussenpersonenApiApiInterface {
    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingInzien</li></ul>
     * @summary Haal alle actieve tussenpersonen op
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TussenpersonenApiApiInterface
     */
    tussenpersonenGet(options?: any): AxiosPromise<CollectionResultOfCrmTussenPersonenTussenPersoonDto>;

}

/**
 * TussenpersonenApiApi - object-oriented interface
 * @export
 * @class TussenpersonenApiApi
 * @extends {BaseAPI}
 */
export class TussenpersonenApiApi extends BaseAPI implements TussenpersonenApiApiInterface {
    /**
     *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingInzien</li></ul>
     * @summary Haal alle actieve tussenpersonen op
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TussenpersonenApiApi
     */
    public tussenpersonenGet(options?: any) {
        return TussenpersonenApiApiFp(this.configuration).tussenpersonenGet(options).then((request) => request(this.axios, this.basePath));
    }
}


